"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeType = void 0;
var FeeType;
(function (FeeType) {
    FeeType["PERCENT"] = "percent";
    FeeType["FIXED"] = "fixed";
})(FeeType || (exports.FeeType = FeeType = {}));
//# sourceMappingURL=enums.js.map